import React, { useState } from 'react';

const UserForm = ({ data, onChange, isEditMode = false }) => {
    const [showPassword, setShowPassword] = useState(false); // State für Passwort-Sichtbarkeit
    const handleChange = (field, value) => {
        onChange({ ...data, [field]: value });
    };

    return (
        <>
            {/* Benutzername */}
            <div className="form-group">
                <label>Benutzername:*</label>
                <input
                    type="text"
                    value={data.username || ''}
                    onChange={(e) => handleChange('username', e.target.value)}
                    required
                    disabled={isEditMode}
                />
            </div>

            {/* Passwort */}
            <div className="form-group">
                <label>
                    Passwort:
                    {isEditMode ? ' (nur bei Änderung)' : ' *'}
                </label>
                <div style={{ position: "relative" }}>
                    <input
                        type={showPassword ? "text" : "password"} // Toggle zwischen text und password
                        value={data.password || ''}
                        onChange={(e) => handleChange('password', e.target.value)}
                        required={!isEditMode}
                        style={{ width: "100%" }}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#6c757d",
                        }}
                    >
                        {showPassword ? "👁️" : "🔒"} {/* Symbol für Sichtbarkeit */}
                    </button>
                </div>
            </div>

            {/* E-Mail */}
            <div className="form-group">
                <label>E-Mail:*</label>
                <input
                    type="email"
                    value={data.email || ''}
                    onChange={(e) => handleChange('email', e.target.value)}
                    required
                />
            </div>

            {/* Rolle */}
            <div className="form-group">
                <label>Rolle:*</label>
                <select
                    value={data.role || 'Normal'}
                    onChange={(e) => handleChange('role', e.target.value)}
                    required
                >
                    <option value="Normal">Normal</option>
                    <option value="Admin">Admin</option>
                </select>
            </div>

            {/* Aktiv-Status (nur im Bearbeitungsmodus anzeigen, aber disabled) */}
            {isEditMode && (
                <div className="form-group checkbox-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={data.active || false}
                            onChange={(e) => handleChange('active', e.target.checked)}
                            disabled
                        />
                        Aktiv
                    </label>
                </div>
            )}
        </>
    );
};

export default UserForm;